// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".signatures-container[data-v-1ad4bd21] {\n  width: 150px;\n  position: relative;\n}\n.signatures-sticky-container[data-v-1ad4bd21] {\n  position: sticky;\n  top: 100px;\n  overflow: auto;\n}", ""]);
// Exports
module.exports = exports;
